<div *ngrxLet="{produit:currentProduit$, caisse:currentCaisse$} as data" class="page">
  <div class="icon" style="position: relative;margin-bottom: 70px">
    <img [src]="data.produit.icon" style="width:88px;position: absolute;top: 0;">
  </div>
  <div class="title">
    {{data.produit.title}}
  </div>
  <div class="container">
    <div class="video">
      <video style="width: 100%;cursor: pointer;" controls="controls" #videoPlayer [src]="data.produit.video"
             (click)="history(data.produit.title)"></video>
    </div>
    <app-dynamic-component style="width: 100%"
                 [components]="components"
                 [caisse]="data.caisse"
                 [queryParams]="queryParams"
                 [user]="user"
                 [element]="data.produit"></app-dynamic-component>
  </div>
</div>

